/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 13/02/2025
 * @Example
 */

import { Notify } from "diginet-core-ui/components";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

const NotifyCom = forwardRef((_, ref) => {
    const notifyRef = useRef(null);
    useImperativeHandle(ref, () => ({ show }));

    const show = (type, message, time, option = {}) => {
        if (!notifyRef.current) return;
        notifyRef.current.add(message, {
            duration: time,
            color: type === "error" ? "danger" : type,
            position: {
                vertical: "bottom",
                horizontal: "center",
            },
            ...option,
        });
    };

    return (
        <Notify
            ref={refs => (notifyRef.current = refs)}
            position={{ vertical: "bottom", horizontal: "center" }}
            autoDisappear
        />
    );
});

export default NotifyCom;
